import * as modifiers from './history.modifiers';
import * as getters from './history.getters';

export default {
  ...modifiers,
  ...getters,
};
